import styled from 'styled-components';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledLeftContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

const StyledRightContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;

	img {
		user-select: none;
		pointer-events: none;
	}
`;

export { StyledContainer, StyledLeftContainer, StyledRightContainer };
